
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms",
      function () {
        return require("private-next-pages/legal/terms.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/terms"])
      });
    }
  